import { browser } from "$app/env";
import type { Fetch } from "@colossus/api-client";

export interface Reader {
  readonly origin: () => string;
  readonly fetch: Fetch;
  readonly pathname: () => string | undefined;
}

const BROWSER: Reader | null = browser
  ? {
      origin: () => globalThis.location.origin,
      fetch: (input, init) => globalThis.fetch(input, init),
      pathname: () => globalThis.location?.pathname,
    }
  : null;

let requestReader: (() => Reader) | null = null;

export const readersFromRequests = (current: () => Reader): void => {
  requestReader = current;
};

export const reader = (): Reader => {
  if (BROWSER !== null) return BROWSER;
  if (requestReader === null) throw new Error("a server read ran outside a request");
  return requestReader();
};

export const perReader = <T>(start: () => T): (() => T) & { readonly of: (at: Reader) => T } => {
  const held = new WeakMap<Reader, T>();
  const of = (at: Reader): T => {
    if (held.has(at)) return held.get(at) as T;
    const value = start();
    held.set(at, value);
    return value;
  };
  return Object.assign(() => of(reader()), { of });
};
